export interface ThemeColors {
  [key: string]: string
}

export interface ThemeDef {
  id: string
  name: string
  preview: [string, string, string, string]
  shared: ThemeColors
  light: ThemeColors
  dark: ThemeColors
}

export const themes: ThemeDef[] = [
  // ═══ Amethyst Haze (default / violet) ═══
  {
    id: 'amethyst',
    name: 'Amethyst Haze',
    preview: [
      'oklch(0.5676 0.2021 283.0838)',
      'oklch(0.3390 0.1793 301.6848)',
      'oklch(0.6746 0.1414 261.3380)',
      'oklch(0.3867 0 0)',
    ],
    shared: {
      '--font-sans': 'Montserrat, sans-serif',
      '--font-serif': 'Playfair Display, serif',
      '--font-mono': 'Source Code Pro, monospace',
      '--radius': '0.5rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '0em',
      '--shadow-2xs': '0px 5px 10px -2px hsl(0 0% 0% / 0.05)',
      '--shadow-xs':  '0px 5px 10px -2px hsl(0 0% 0% / 0.05)',
      '--shadow-sm':  '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
      '--shadow':     '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
      '--shadow-md':  '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 2px 4px -3px hsl(0 0% 0% / 0.10)',
      '--shadow-lg':  '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 4px 6px -3px hsl(0 0% 0% / 0.10)',
      '--shadow-xl':  '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 8px 10px -3px hsl(0 0% 0% / 0.10)',
      '--shadow-2xl': '0px 5px 10px -2px hsl(0 0% 0% / 0.25)',
    },
    light: {
      '--background': 'oklch(0.9821 0 0)', '--foreground': 'oklch(0.3211 0 0)',
      '--card': 'oklch(1.0000 0 0)', '--card-foreground': 'oklch(0.3211 0 0)',
      '--popover': 'oklch(1.0000 0 0)', '--popover-foreground': 'oklch(0.3211 0 0)',
      '--primary': 'oklch(0.5676 0.2021 283.0838)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.8214 0.0720 249.3482)', '--secondary-foreground': 'oklch(0.3211 0 0)',
      '--muted': 'oklch(0.8202 0.0213 91.6163)', '--muted-foreground': 'oklch(0.5382 0 0)',
      '--accent': 'oklch(0.9500 0.0100 264)', '--accent-foreground': 'oklch(0.3211 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.8699 0 0)', '--input': 'oklch(0.8699 0 0)',
      '--ring': 'oklch(0.5676 0.2021 283.0838)',
      '--chart-1': 'oklch(0.5676 0.2021 283.0838)', '--chart-2': 'oklch(0.5261 0.1705 314.6534)',
      '--chart-3': 'oklch(0.3390 0.1793 301.6848)', '--chart-4': 'oklch(0.6746 0.1414 261.3380)',
      '--chart-5': 'oklch(0.5880 0.0993 245.7394)',
      '--sidebar': 'oklch(0.9821 0 0)', '--sidebar-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-primary': 'oklch(0.5676 0.2021 283.0838)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.9500 0.0100 264)', '--sidebar-accent-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-border': 'oklch(0.8699 0 0)', '--sidebar-ring': 'oklch(0.5676 0.2021 283.0838)',
    },
    dark: {
      '--background': 'oklch(0.2303 0.0125 264.2926)', '--foreground': 'oklch(0.9219 0 0)',
      '--card': 'oklch(0.3210 0.0078 223.6661)', '--card-foreground': 'oklch(0.9219 0 0)',
      '--popover': 'oklch(0.3210 0.0078 223.6661)', '--popover-foreground': 'oklch(0.9219 0 0)',
      '--primary': 'oklch(0.5676 0.2021 283.0838)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.3390 0.1793 301.6848)', '--secondary-foreground': 'oklch(0.9219 0 0)',
      '--muted': 'oklch(0.3867 0 0)', '--muted-foreground': 'oklch(0.7155 0 0)',
      '--accent': 'oklch(0.3000 0.0100 264)', '--accent-foreground': 'oklch(0.9219 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3867 0 0)', '--input': 'oklch(0.3867 0 0)',
      '--ring': 'oklch(0.5676 0.2021 283.0838)',
      '--chart-1': 'oklch(0.5676 0.2021 283.0838)', '--chart-2': 'oklch(0.5261 0.1705 314.6534)',
      '--chart-3': 'oklch(0.3390 0.1793 301.6848)', '--chart-4': 'oklch(0.6746 0.1414 261.3380)',
      '--chart-5': 'oklch(0.5880 0.0993 245.7394)',
      '--sidebar': 'oklch(0.2303 0.0125 264.2926)', '--sidebar-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-primary': 'oklch(0.5676 0.2021 283.0838)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.3000 0.0100 264)', '--sidebar-accent-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-border': 'oklch(0.3867 0 0)', '--sidebar-ring': 'oklch(0.5676 0.2021 283.0838)',
    },
  },

  // ═══ Amber Minimal ═══
  {
    id: 'amber',
    name: 'Amber Minimal',
    preview: [
      'oklch(0.7686 0.1647 70.0804)',
      'oklch(0.2686 0 0)',
      'oklch(0.4732 0.1247 46.2007)',
      'oklch(0.2393 0 0)',
    ],
    shared: {
      '--font-sans': 'Inter, sans-serif',
      '--font-serif': 'Source Serif 4, serif',
      '--font-mono': 'JetBrains Mono, monospace',
      '--radius': '0.375rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '0em',
      '--shadow-2xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
      '--shadow-xs':  '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
      '--shadow-sm':  '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
      '--shadow':     '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
      '--shadow-md':  '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 2px 4px -2px hsl(0 0% 0% / 0.10)',
      '--shadow-lg':  '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 4px 6px -2px hsl(0 0% 0% / 0.10)',
      '--shadow-xl':  '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 8px 10px -2px hsl(0 0% 0% / 0.10)',
      '--shadow-2xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.25)',
    },
    light: {
      '--background': 'oklch(1.0000 0 0)', '--foreground': 'oklch(0.2686 0 0)',
      '--card': 'oklch(1.0000 0 0)', '--card-foreground': 'oklch(0.2686 0 0)',
      '--popover': 'oklch(1.0000 0 0)', '--popover-foreground': 'oklch(0.2686 0 0)',
      '--primary': 'oklch(0.7686 0.1647 70.0804)', '--primary-foreground': 'oklch(0 0 0)',
      '--secondary': 'oklch(0.9670 0.0029 264.5419)', '--secondary-foreground': 'oklch(0.4461 0.0263 256.8018)',
      '--muted': 'oklch(0.9846 0.0017 247.8389)', '--muted-foreground': 'oklch(0.5510 0.0234 264.3637)',
      '--accent': 'oklch(0.9869 0.0214 95.2774)', '--accent-foreground': 'oklch(0.2686 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.9276 0.0058 264.5313)', '--input': 'oklch(0.9276 0.0058 264.5313)',
      '--ring': 'oklch(0.7686 0.1647 70.0804)',
      '--chart-1': 'oklch(0.7686 0.1647 70.0804)', '--chart-2': 'oklch(0.6658 0.1574 58.3183)',
      '--chart-3': 'oklch(0.5553 0.1455 48.9975)', '--chart-4': 'oklch(0.4732 0.1247 46.2007)',
      '--chart-5': 'oklch(0.4137 0.1054 45.9038)',
      '--sidebar': 'oklch(0.9846 0.0017 247.8389)', '--sidebar-foreground': 'oklch(0.2686 0 0)',
      '--sidebar-primary': 'oklch(0.7686 0.1647 70.0804)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.9869 0.0214 95.2774)', '--sidebar-accent-foreground': 'oklch(0.2686 0 0)',
      '--sidebar-border': 'oklch(0.9276 0.0058 264.5313)', '--sidebar-ring': 'oklch(0.7686 0.1647 70.0804)',
    },
    dark: {
      '--background': 'oklch(0.2046 0 0)', '--foreground': 'oklch(0.9219 0 0)',
      '--card': 'oklch(0.2686 0 0)', '--card-foreground': 'oklch(0.9219 0 0)',
      '--popover': 'oklch(0.2686 0 0)', '--popover-foreground': 'oklch(0.9219 0 0)',
      '--primary': 'oklch(0.7686 0.1647 70.0804)', '--primary-foreground': 'oklch(0 0 0)',
      '--secondary': 'oklch(0.2686 0 0)', '--secondary-foreground': 'oklch(0.9219 0 0)',
      '--muted': 'oklch(0.2393 0 0)', '--muted-foreground': 'oklch(0.7155 0 0)',
      '--accent': 'oklch(0.3000 0.0100 70)', '--accent-foreground': 'oklch(0.9219 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3715 0 0)', '--input': 'oklch(0.3715 0 0)',
      '--ring': 'oklch(0.7686 0.1647 70.0804)',
      '--chart-1': 'oklch(0.8369 0.1644 84.4286)', '--chart-2': 'oklch(0.6658 0.1574 58.3183)',
      '--chart-3': 'oklch(0.4732 0.1247 46.2007)', '--chart-4': 'oklch(0.5553 0.1455 48.9975)',
      '--chart-5': 'oklch(0.4732 0.1247 46.2007)',
      '--sidebar': 'oklch(0.1684 0 0)', '--sidebar-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-primary': 'oklch(0.7686 0.1647 70.0804)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.3000 0.0100 70)', '--sidebar-accent-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-border': 'oklch(0.3715 0 0)', '--sidebar-ring': 'oklch(0.7686 0.1647 70.0804)',
    },
  },

  // ═══ Terra ═══
  {
    id: 'terra',
    name: 'Terra',
    preview: [
      'oklch(0.6724 0.1308 38.7559)',
      'oklch(0.9818 0.0054 95.0986)',
      'oklch(0.2130 0.0078 95.4245)',
      'oklch(0.2213 0.0038 106.7070)',
    ],
    shared: {
      '--font-sans': "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
      '--font-serif': "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif",
      '--font-mono': "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
      '--radius': '0.5rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '0em',
      '--shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-xs':  '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-sm':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow':     '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-md':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-lg':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-xl':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
    },
    light: {
      '--background': 'oklch(0.9818 0.0054 95.0986)', '--foreground': 'oklch(0.3438 0.0269 95.7226)',
      '--card': 'oklch(0.9818 0.0054 95.0986)', '--card-foreground': 'oklch(0.1908 0.0020 106.5859)',
      '--popover': 'oklch(1.0000 0 0)', '--popover-foreground': 'oklch(0.2671 0.0196 98.9390)',
      '--primary': 'oklch(0.6171 0.1375 39.0427)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.9245 0.0138 92.9892)', '--secondary-foreground': 'oklch(0.4334 0.0177 98.6048)',
      '--muted': 'oklch(0.9341 0.0153 90.2390)', '--muted-foreground': 'oklch(0.6059 0.0075 97.4233)',
      '--accent': 'oklch(0.9245 0.0138 92.9892)', '--accent-foreground': 'oklch(0.2671 0.0196 98.9390)',
      '--destructive': 'oklch(0.1908 0.0020 106.5859)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.8847 0.0069 97.3627)', '--input': 'oklch(0.7621 0.0156 98.3528)',
      '--ring': 'oklch(0.6171 0.1375 39.0427)',
      '--chart-1': 'oklch(0.5583 0.1276 42.9956)', '--chart-2': 'oklch(0.6898 0.1581 290.4107)',
      '--chart-3': 'oklch(0.8816 0.0276 93.1280)', '--chart-4': 'oklch(0.8822 0.0403 298.1792)',
      '--chart-5': 'oklch(0.5608 0.1348 42.0584)',
      '--sidebar': 'oklch(0.9663 0.0080 98.8792)', '--sidebar-foreground': 'oklch(0.3590 0.0051 106.6524)',
      '--sidebar-primary': 'oklch(0.6171 0.1375 39.0427)', '--sidebar-primary-foreground': 'oklch(0.9881 0 0)',
      '--sidebar-accent': 'oklch(0.9245 0.0138 92.9892)', '--sidebar-accent-foreground': 'oklch(0.3250 0 0)',
      '--sidebar-border': 'oklch(0.9401 0 0)', '--sidebar-ring': 'oklch(0.7731 0 0)',
    },
    dark: {
      '--background': 'oklch(0.2679 0.0036 106.6427)', '--foreground': 'oklch(0.8074 0.0142 93.0137)',
      '--card': 'oklch(0.2679 0.0036 106.6427)', '--card-foreground': 'oklch(0.9818 0.0054 95.0986)',
      '--popover': 'oklch(0.3085 0.0035 106.6039)', '--popover-foreground': 'oklch(0.9211 0.0040 106.4781)',
      '--primary': 'oklch(0.6724 0.1308 38.7559)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.9818 0.0054 95.0986)', '--secondary-foreground': 'oklch(0.3085 0.0035 106.6039)',
      '--muted': 'oklch(0.2213 0.0038 106.7070)', '--muted-foreground': 'oklch(0.7713 0.0169 99.0657)',
      '--accent': 'oklch(0.3100 0.0060 95)', '--accent-foreground': 'oklch(0.8074 0.0142 93.0137)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3618 0.0101 106.8928)', '--input': 'oklch(0.4336 0.0113 100.2195)',
      '--ring': 'oklch(0.6724 0.1308 38.7559)',
      '--chart-1': 'oklch(0.5583 0.1276 42.9956)', '--chart-2': 'oklch(0.6898 0.1581 290.4107)',
      '--chart-3': 'oklch(0.2130 0.0078 95.4245)', '--chart-4': 'oklch(0.3074 0.0516 289.3230)',
      '--chart-5': 'oklch(0.5608 0.1348 42.0584)',
      '--sidebar': 'oklch(0.2357 0.0024 67.7077)', '--sidebar-foreground': 'oklch(0.8074 0.0142 93.0137)',
      '--sidebar-primary': 'oklch(0.3250 0 0)', '--sidebar-primary-foreground': 'oklch(0.9881 0 0)',
      '--sidebar-accent': 'oklch(0.2800 0.0040 106)', '--sidebar-accent-foreground': 'oklch(0.8074 0.0142 93.0137)',
      '--sidebar-border': 'oklch(0.9401 0 0)', '--sidebar-ring': 'oklch(0.7731 0 0)',
    },
  },

  // ═══ Ocean Breeze ═══
  {
    id: 'ocean',
    name: 'Ocean Breeze',
    preview: [
      'oklch(0.6487 0.1538 150.3071)',
      'oklch(0.6746 0.1414 261.3380)',
      'oklch(0.6746 0.1414 261.3380)',
      'oklch(0.3867 0 0)',
    ],
    shared: {
      '--font-sans': 'Plus Jakarta Sans, sans-serif',
      '--font-serif': 'Source Serif 4, serif',
      '--font-mono': 'JetBrains Mono, monospace',
      '--radius': '0.5rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '0em',
      '--shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-xs':  '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-sm':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow':     '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-md':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-lg':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-xl':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
    },
    light: {
      '--background': 'oklch(0.9824 0.0013 286.3757)', '--foreground': 'oklch(0.3211 0 0)',
      '--card': 'oklch(1.0000 0 0)', '--card-foreground': 'oklch(0.3211 0 0)',
      '--popover': 'oklch(1.0000 0 0)', '--popover-foreground': 'oklch(0.3211 0 0)',
      '--primary': 'oklch(0.6487 0.1538 150.3071)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.6746 0.1414 261.3380)', '--secondary-foreground': 'oklch(1.0000 0 0)',
      '--muted': 'oklch(0.8828 0.0285 98.1033)', '--muted-foreground': 'oklch(0.5382 0 0)',
      '--accent': 'oklch(0.9500 0.0150 212)', '--accent-foreground': 'oklch(0.3211 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.8699 0 0)', '--input': 'oklch(0.8699 0 0)',
      '--ring': 'oklch(0.6487 0.1538 150.3071)',
      '--chart-1': 'oklch(0.6487 0.1538 150.3071)', '--chart-2': 'oklch(0.6746 0.1414 261.3380)',
      '--chart-3': 'oklch(0.8269 0.1080 211.9627)', '--chart-4': 'oklch(0.5880 0.0993 245.7394)',
      '--chart-5': 'oklch(0.5905 0.1608 148.2409)',
      '--sidebar': 'oklch(0.9824 0.0013 286.3757)', '--sidebar-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-primary': 'oklch(0.6487 0.1538 150.3071)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.9500 0.0150 212)', '--sidebar-accent-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-border': 'oklch(0.8699 0 0)', '--sidebar-ring': 'oklch(0.6487 0.1538 150.3071)',
    },
    dark: {
      '--background': 'oklch(0.2303 0.0125 264.2926)', '--foreground': 'oklch(0.9219 0 0)',
      '--card': 'oklch(0.3210 0.0078 223.6661)', '--card-foreground': 'oklch(0.9219 0 0)',
      '--popover': 'oklch(0.3210 0.0078 223.6661)', '--popover-foreground': 'oklch(0.9219 0 0)',
      '--primary': 'oklch(0.6487 0.1538 150.3071)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.5880 0.0993 245.7394)', '--secondary-foreground': 'oklch(0.9219 0 0)',
      '--muted': 'oklch(0.3867 0 0)', '--muted-foreground': 'oklch(0.7155 0 0)',
      '--accent': 'oklch(0.3000 0.0120 264)', '--accent-foreground': 'oklch(0.9219 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3867 0 0)', '--input': 'oklch(0.3867 0 0)',
      '--ring': 'oklch(0.6487 0.1538 150.3071)',
      '--chart-1': 'oklch(0.6487 0.1538 150.3071)', '--chart-2': 'oklch(0.5880 0.0993 245.7394)',
      '--chart-3': 'oklch(0.6746 0.1414 261.3380)', '--chart-4': 'oklch(0.8269 0.1080 211.9627)',
      '--chart-5': 'oklch(0.5905 0.1608 148.2409)',
      '--sidebar': 'oklch(0.2303 0.0125 264.2926)', '--sidebar-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-primary': 'oklch(0.6487 0.1538 150.3071)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.3000 0.0120 264)', '--sidebar-accent-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-border': 'oklch(0.3867 0 0)', '--sidebar-ring': 'oklch(0.6487 0.1538 150.3071)',
    },
  },

  // ═══ Deep Blue ═══
  {
    id: 'deepblue',
    name: 'Deep Blue',
    preview: [
      'oklch(0.6397 0.1720 36.4421)',
      'oklch(0.3095 0.0266 266.7132)',
      'oklch(0.3380 0.0589 267.5867)',
      'oklch(0.3095 0.0266 266.7132)',
    ],
    shared: {
      '--font-sans': 'Inter, sans-serif',
      '--font-serif': 'Source Serif 4, serif',
      '--font-mono': 'JetBrains Mono, monospace',
      '--radius': '0.75rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '0em',
      '--shadow-2xs': '0px 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-xs':  '0px 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-sm':  '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow':     '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-md':  '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 2px 4px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-lg':  '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 4px 6px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-xl':  '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 8px 10px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-2xl': '0px 1px 3px 0px hsl(0 0% 0% / 0.25)',
    },
    light: {
      '--background': 'oklch(0.9383 0.0042 236.4993)', '--foreground': 'oklch(0.3211 0 0)',
      '--card': 'oklch(1.0000 0 0)', '--card-foreground': 'oklch(0.3211 0 0)',
      '--popover': 'oklch(1.0000 0 0)', '--popover-foreground': 'oklch(0.3211 0 0)',
      '--primary': 'oklch(0.6397 0.1720 36.4421)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.9670 0.0029 264.5419)', '--secondary-foreground': 'oklch(0.4461 0.0263 256.8018)',
      '--muted': 'oklch(0.9846 0.0017 247.8389)', '--muted-foreground': 'oklch(0.5510 0.0234 264.3637)',
      '--accent': 'oklch(0.9119 0.0222 243.8174)', '--accent-foreground': 'oklch(0.3211 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.9022 0.0052 247.8822)', '--input': 'oklch(0.9700 0.0029 264.5420)',
      '--ring': 'oklch(0.6397 0.1720 36.4421)',
      '--chart-1': 'oklch(0.7156 0.0605 248.6845)', '--chart-2': 'oklch(0.7875 0.0917 35.9616)',
      '--chart-3': 'oklch(0.5778 0.0759 254.1573)', '--chart-4': 'oklch(0.5016 0.0849 259.4902)',
      '--chart-5': 'oklch(0.4241 0.0952 264.0306)',
      '--sidebar': 'oklch(0.9030 0.0046 258.3257)', '--sidebar-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-primary': 'oklch(0.6397 0.1720 36.4421)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.9119 0.0222 243.8174)', '--sidebar-accent-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-border': 'oklch(0.9276 0.0058 264.5313)', '--sidebar-ring': 'oklch(0.6397 0.1720 36.4421)',
    },
    dark: {
      '--background': 'oklch(0.2598 0.0306 262.6666)', '--foreground': 'oklch(0.9219 0 0)',
      '--card': 'oklch(0.3106 0.0301 268.6365)', '--card-foreground': 'oklch(0.9219 0 0)',
      '--popover': 'oklch(0.2900 0.0249 268.3986)', '--popover-foreground': 'oklch(0.9219 0 0)',
      '--primary': 'oklch(0.6397 0.1720 36.4421)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.3095 0.0266 266.7132)', '--secondary-foreground': 'oklch(0.9219 0 0)',
      '--muted': 'oklch(0.3095 0.0266 266.7132)', '--muted-foreground': 'oklch(0.7155 0 0)',
      '--accent': 'oklch(0.3200 0.0180 267)', '--accent-foreground': 'oklch(0.9219 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3843 0.0301 269.7337)', '--input': 'oklch(0.3843 0.0301 269.7337)',
      '--ring': 'oklch(0.6397 0.1720 36.4421)',
      '--chart-1': 'oklch(0.7156 0.0605 248.6845)', '--chart-2': 'oklch(0.7693 0.0876 34.1875)',
      '--chart-3': 'oklch(0.5778 0.0759 254.1573)', '--chart-4': 'oklch(0.5016 0.0849 259.4902)',
      '--chart-5': 'oklch(0.4241 0.0952 264.0306)',
      '--sidebar': 'oklch(0.3100 0.0283 267.7408)', '--sidebar-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-primary': 'oklch(0.6397 0.1720 36.4421)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.3200 0.0180 267)', '--sidebar-accent-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-border': 'oklch(0.3843 0.0301 269.7337)', '--sidebar-ring': 'oklch(0.6397 0.1720 36.4421)',
    },
  },

  // ═══ Eclipse ═══
  {
    id: 'eclipse',
    name: 'Eclipse',
    preview: [
      'oklch(0.6132 0.2294 291.7437)',
      'oklch(0.2940 0.0130 272.9312)',
      'oklch(0.2795 0.0368 260.0310)',
      'oklch(0.2940 0.0130 272.9312)',
    ],
    shared: {
      '--font-sans': 'Plus Jakarta Sans, sans-serif',
      '--font-serif': 'Lora, serif',
      '--font-mono': 'IBM Plex Mono, monospace',
      '--radius': '1.4rem',
      '--spacing': '0.27rem',
      '--tracking-normal': '-0.025em',
      '--shadow-2xs': '0px 2px 3px 0px hsl(0 0% 0% / 0.08)',
      '--shadow-xs':  '0px 2px 3px 0px hsl(0 0% 0% / 0.08)',
      '--shadow-sm':  '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 1px 2px -1px hsl(0 0% 0% / 0.16)',
      '--shadow':     '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 1px 2px -1px hsl(0 0% 0% / 0.16)',
      '--shadow-md':  '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 2px 4px -1px hsl(0 0% 0% / 0.16)',
      '--shadow-lg':  '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 4px 6px -1px hsl(0 0% 0% / 0.16)',
      '--shadow-xl':  '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 8px 10px -1px hsl(0 0% 0% / 0.16)',
      '--shadow-2xl': '0px 2px 3px 0px hsl(0 0% 0% / 0.40)',
    },
    light: {
      '--background': 'oklch(0.9940 0 0)', '--foreground': 'oklch(0 0 0)',
      '--card': 'oklch(0.9940 0 0)', '--card-foreground': 'oklch(0 0 0)',
      '--popover': 'oklch(0.9911 0 0)', '--popover-foreground': 'oklch(0 0 0)',
      '--primary': 'oklch(0.5393 0.2713 286.7462)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.9540 0.0063 255.4755)', '--secondary-foreground': 'oklch(0.1344 0 0)',
      '--muted': 'oklch(0.9702 0 0)', '--muted-foreground': 'oklch(0.4386 0 0)',
      '--accent': 'oklch(0.9393 0.0288 266.3680)', '--accent-foreground': 'oklch(0 0 0)',
      '--destructive': 'oklch(0.6290 0.1902 23.0704)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.9300 0.0094 286.2156)', '--input': 'oklch(0.9401 0 0)',
      '--ring': 'oklch(0 0 0)',
      '--chart-1': 'oklch(0.7459 0.1483 156.4499)', '--chart-2': 'oklch(0.5393 0.2713 286.7462)',
      '--chart-3': 'oklch(0.7336 0.1758 50.5517)', '--chart-4': 'oklch(0.5828 0.1809 259.7276)',
      '--chart-5': 'oklch(0.5590 0 0)',
      '--sidebar': 'oklch(0.9777 0.0051 247.8763)', '--sidebar-foreground': 'oklch(0 0 0)',
      '--sidebar-primary': 'oklch(0 0 0)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.9401 0 0)', '--sidebar-accent-foreground': 'oklch(0 0 0)',
      '--sidebar-border': 'oklch(0.9401 0 0)', '--sidebar-ring': 'oklch(0 0 0)',
    },
    dark: {
      '--background': 'oklch(0.2223 0.0060 271.1393)', '--foreground': 'oklch(0.9551 0 0)',
      '--card': 'oklch(0.2568 0.0076 274.6528)', '--card-foreground': 'oklch(0.9551 0 0)',
      '--popover': 'oklch(0.2568 0.0076 274.6528)', '--popover-foreground': 'oklch(0.9551 0 0)',
      '--primary': 'oklch(0.6132 0.2294 291.7437)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.2940 0.0130 272.9312)', '--secondary-foreground': 'oklch(0.9551 0 0)',
      '--muted': 'oklch(0.2940 0.0130 272.9312)', '--muted-foreground': 'oklch(0.7058 0 0)',
      '--accent': 'oklch(0.2900 0.0150 260)', '--accent-foreground': 'oklch(0.9551 0 0)',
      '--destructive': 'oklch(0.7106 0.1661 22.2162)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3289 0.0092 268.3843)', '--input': 'oklch(0.3289 0.0092 268.3843)',
      '--ring': 'oklch(0.6132 0.2294 291.7437)',
      '--chart-1': 'oklch(0.8003 0.1821 151.7110)', '--chart-2': 'oklch(0.6132 0.2294 291.7437)',
      '--chart-3': 'oklch(0.8077 0.1035 19.5706)', '--chart-4': 'oklch(0.6691 0.1569 260.1063)',
      '--chart-5': 'oklch(0.7058 0 0)',
      '--sidebar': 'oklch(0.2011 0.0039 286.0396)', '--sidebar-foreground': 'oklch(0.9551 0 0)',
      '--sidebar-primary': 'oklch(0.6132 0.2294 291.7437)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.2940 0.0130 272.9312)', '--sidebar-accent-foreground': 'oklch(0.9551 0 0)',
      '--sidebar-border': 'oklch(0.3289 0.0092 268.3843)', '--sidebar-ring': 'oklch(0.6132 0.2294 291.7437)',
    },
  },

  // ═══ Terminal ═══
  {
    id: 'terminal',
    name: 'Terminal',
    preview: [
      'oklch(0.6369 0.1241 153.2123)',
      'oklch(0.1742 0.0094 157.4975)',
      'oklch(0.2761 0.0139 157.5773)',
      'oklch(0.2797 0.0207 157.0037)',
    ],
    shared: {
      '--font-sans': "ui-monospace, 'JetBrains Mono', 'Fira Code', 'Menlo', monospace",
      '--font-serif': "ui-monospace, 'JetBrains Mono', 'Fira Code', 'Menlo', monospace",
      '--font-mono': "ui-monospace, 'JetBrains Mono', 'Fira Code', 'Menlo', monospace",
      '--radius': '0rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '-0.01em',
      '--shadow-2xs': '2px 2px 0px 0px hsl(0 0% 0% / 0.06)',
      '--shadow-xs':  '2px 2px 0px 0px hsl(0 0% 0% / 0.06)',
      '--shadow-sm':  '2px 2px 0px 0px hsl(0 0% 0% / 0.12)',
      '--shadow':     '2px 2px 0px 0px hsl(0 0% 0% / 0.16)',
      '--shadow-md':  '3px 3px 0px 0px hsl(0 0% 0% / 0.16)',
      '--shadow-lg':  '3px 3px 0px 0px hsl(0 0% 0% / 0.20)',
      '--shadow-xl':  '4px 4px 0px 0px hsl(0 0% 0% / 0.24)',
      '--shadow-2xl': '5px 5px 0px 0px hsl(0 0% 0% / 0.32)',
    },
    light: {
      '--background': 'oklch(0.9641 0.0052 158.6031)', '--foreground': 'oklch(0.2836 0.0272 156.4301)',
      '--card': 'oklch(0.9424 0.0083 158.5279)', '--card-foreground': 'oklch(0.2253 0.0193 156.7013)',
      '--popover': 'oklch(0.9424 0.0083 158.5279)', '--popover-foreground': 'oklch(0.2253 0.0193 156.7013)',
      '--primary': 'oklch(0.5313 0.1014 153.3713)', '--primary-foreground': 'oklch(0.9854 0.0014 158.6880)',
      '--secondary': 'oklch(0.5852 0.0854 61.1363)', '--secondary-foreground': 'oklch(0.9850 0.0009 64.0793)',
      '--muted': 'oklch(0.9115 0.0084 158.5197)', '--muted-foreground': 'oklch(0.4858 0.0418 156.6920)',
      '--accent': 'oklch(0.9300 0.0080 158)', '--accent-foreground': 'oklch(0.2836 0.0272 156.4301)',
      '--destructive': 'oklch(0.5107 0.1226 22.3963)', '--destructive-foreground': 'oklch(0.9848 0 0)',
      '--border': 'oklch(0.8513 0.0142 158.3553)', '--input': 'oklch(0.9263 0.0069 158.5564)',
      '--ring': 'oklch(0.5313 0.1014 153.3713)',
      '--chart-1': 'oklch(0.5313 0.1014 153.3713)', '--chart-2': 'oklch(0.5852 0.0854 61.1363)',
      '--chart-3': 'oklch(0.4858 0.0418 156.6920)', '--chart-4': 'oklch(0.6400 0.0900 153.0000)',
      '--chart-5': 'oklch(0.4000 0.0800 153.0000)',
      '--sidebar': 'oklch(0.9278 0.0104 158.4750)', '--sidebar-foreground': 'oklch(0.3391 0.0346 156.2653)',
      '--sidebar-primary': 'oklch(0.5313 0.1014 153.3713)', '--sidebar-primary-foreground': 'oklch(0.9854 0.0014 158.6880)',
      '--sidebar-accent': 'oklch(0.9300 0.0080 158)', '--sidebar-accent-foreground': 'oklch(0.2836 0.0272 156.4301)',
      '--sidebar-border': 'oklch(0.8513 0.0142 158.3553)', '--sidebar-ring': 'oklch(0.5313 0.1014 153.3713)',
    },
    dark: {
      '--background': 'oklch(0.1487 0.0066 158.2141)', '--foreground': 'oklch(0.8352 0.0611 157.0203)',
      '--card': 'oklch(0.1742 0.0094 157.4975)', '--card-foreground': 'oklch(0.9010 0.0364 157.8146)',
      '--popover': 'oklch(0.1742 0.0094 157.4975)', '--popover-foreground': 'oklch(0.9010 0.0364 157.8146)',
      '--primary': 'oklch(0.6369 0.1241 153.2123)', '--primary-foreground': 'oklch(0.1616 0.0080 157.6046)',
      '--secondary': 'oklch(0.5961 0.1041 59.8452)', '--secondary-foreground': 'oklch(0.1591 0.0051 63.6710)',
      '--muted': 'oklch(0.2429 0.0115 157.6493)', '--muted-foreground': 'oklch(0.6747 0.0656 156.3922)',
      '--accent': 'oklch(0.2761 0.0139 157.5773)', '--accent-foreground': 'oklch(0.9010 0.0364 157.8146)',
      '--destructive': 'oklch(0.5119 0.1503 24.1184)', '--destructive-foreground': 'oklch(0.9848 0 0)',
      '--border': 'oklch(0.2797 0.0207 157.0037)', '--input': 'oklch(0.2226 0.0146 157.2073)',
      '--ring': 'oklch(0.6369 0.1241 153.2123)',
      '--chart-1': 'oklch(0.6369 0.1241 153.2123)', '--chart-2': 'oklch(0.5961 0.1041 59.8452)',
      '--chart-3': 'oklch(0.6747 0.0656 156.3922)', '--chart-4': 'oklch(0.7500 0.1100 153.0000)',
      '--chart-5': 'oklch(0.5000 0.0900 153.0000)',
      '--sidebar': 'oklch(0.1616 0.0080 157.6046)', '--sidebar-foreground': 'oklch(0.8352 0.0611 157.0203)',
      '--sidebar-primary': 'oklch(0.6369 0.1241 153.2123)', '--sidebar-primary-foreground': 'oklch(0.1616 0.0080 157.6046)',
      '--sidebar-accent': 'oklch(0.2761 0.0139 157.5773)', '--sidebar-accent-foreground': 'oklch(0.9010 0.0364 157.8146)',
      '--sidebar-border': 'oklch(0.2797 0.0207 157.0037)', '--sidebar-ring': 'oklch(0.6369 0.1241 153.2123)',
    },
  },

  // ═══ Ember ═══
  {
    id: 'ember',
    name: 'Ember',
    preview: [
      'oklch(0.7122 0.1809 21.6630)',
      'oklch(0.1448 0 0)',
      'oklch(0.2686 0 0)',
      'oklch(0.2686 0 0)',
    ],
    shared: {
      '--font-sans': "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
      '--font-serif': "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif",
      '--font-mono': "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
      '--radius': '0.5rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '0em',
      '--shadow-2xs': '0 0 #0000',
      '--shadow-xs':  '0 0 #0000',
      '--shadow-sm':  '0 0 #0000',
      '--shadow':     '0 0 #0000',
      '--shadow-md':  '0 0 #0000',
      '--shadow-lg':  '0 0 #0000',
      '--shadow-xl':  '0 0 #0000',
      '--shadow-2xl': '0 0 #0000',
    },
    light: {
      '--background': 'oklch(1.0000 0 0)', '--foreground': 'oklch(0.1448 0 0)',
      '--card': 'oklch(1.0000 0 0)', '--card-foreground': 'oklch(0.1448 0 0)',
      '--popover': 'oklch(1.0000 0 0)', '--popover-foreground': 'oklch(0.1448 0 0)',
      '--primary': 'oklch(0.7122 0.1809 21.6630)', '--primary-foreground': 'oklch(0.9851 0 0)',
      '--secondary': 'oklch(0.9702 0 0)', '--secondary-foreground': 'oklch(0.2046 0 0)',
      '--muted': 'oklch(0.9702 0 0)', '--muted-foreground': 'oklch(0.5555 0 0)',
      '--accent': 'oklch(0.9702 0 0)', '--accent-foreground': 'oklch(0.2046 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.9219 0 0)', '--input': 'oklch(0.9219 0 0)',
      '--ring': 'oklch(0.1448 0 0)',
      '--chart-1': 'oklch(0.7122 0.1809 21.6630)', '--chart-2': 'oklch(0.6368 0.2078 25.3313)',
      '--chart-3': 'oklch(0.7800 0.1500 40.0000)', '--chart-4': 'oklch(0.5555 0 0)',
      '--chart-5': 'oklch(0.8500 0.1200 30.0000)',
      '--sidebar': 'oklch(0.9702 0 0)', '--sidebar-foreground': 'oklch(0.1448 0 0)',
      '--sidebar-primary': 'oklch(0.7122 0.1809 21.6630)', '--sidebar-primary-foreground': 'oklch(0.9851 0 0)',
      '--sidebar-accent': 'oklch(0.9702 0 0)', '--sidebar-accent-foreground': 'oklch(0.2046 0 0)',
      '--sidebar-border': 'oklch(0.9219 0 0)', '--sidebar-ring': 'oklch(0.1448 0 0)',
    },
    dark: {
      '--background': 'oklch(0.1448 0 0)', '--foreground': 'oklch(0.9851 0 0)',
      '--card': 'oklch(0.2046 0 0)', '--card-foreground': 'oklch(0.9851 0 0)',
      '--popover': 'oklch(0.2046 0 0)', '--popover-foreground': 'oklch(0.9851 0 0)',
      '--primary': 'oklch(0.7122 0.1809 21.6630)', '--primary-foreground': 'oklch(0.2046 0 0)',
      '--secondary': 'oklch(0.2686 0 0)', '--secondary-foreground': 'oklch(0.9851 0 0)',
      '--muted': 'oklch(0.2686 0 0)', '--muted-foreground': 'oklch(0.7155 0 0)',
      '--accent': 'oklch(0.2686 0 0)', '--accent-foreground': 'oklch(0.9851 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.2686 0 0)', '--input': 'oklch(0.2686 0 0)',
      '--ring': 'oklch(0.8699 0 0)',
      '--chart-1': 'oklch(0.7122 0.1809 21.6630)', '--chart-2': 'oklch(0.6368 0.2078 25.3313)',
      '--chart-3': 'oklch(0.7800 0.1500 40.0000)', '--chart-4': 'oklch(0.5555 0 0)',
      '--chart-5': 'oklch(0.8500 0.1200 30.0000)',
      '--sidebar': 'oklch(0.1448 0 0)', '--sidebar-foreground': 'oklch(0.9851 0 0)',
      '--sidebar-primary': 'oklch(0.7122 0.1809 21.6630)', '--sidebar-primary-foreground': 'oklch(0.2046 0 0)',
      '--sidebar-accent': 'oklch(0.2686 0 0)', '--sidebar-accent-foreground': 'oklch(0.9851 0 0)',
      '--sidebar-border': 'oklch(0.2686 0 0)', '--sidebar-ring': 'oklch(0.8699 0 0)',
    },
  },

  // ═══ Sunset ═══
  {
    id: 'sunset',
    name: 'Sunset',
    preview: [
      'oklch(0.6730 0.2146 25.0397)',
      'oklch(0.1408 0.0044 285.8229)',
      'oklch(0.7845 0.1325 181.9120)',
      'oklch(0.2739 0.0055 286.0326)',
    ],
    shared: {
      '--font-sans': 'Alegreya Sans, ui-sans-serif, sans-serif, system-ui',
      '--font-serif': 'Alegreya, serif',
      '--font-mono': 'JetBrains Mono, monospace',
      '--radius': '0.75rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '-0.01em',
      '--shadow-2xs': '0 1px 3px 0px hsl(0 100% 65% / 0.04)',
      '--shadow-xs':  '0 1px 3px 0px hsl(0 100% 65% / 0.06)',
      '--shadow-sm':  '0 2px 6px -1px hsl(0 100% 65% / 0.08)',
      '--shadow':     '0 4px 12px -2px hsl(0 100% 65% / 0.10)',
      '--shadow-md':  '0 6px 18px -4px hsl(0 100% 65% / 0.12)',
      '--shadow-lg':  '0 8px 24px -4px hsl(0 100% 65% / 0.15)',
      '--shadow-xl':  '0 0px 40px -10px hsl(0 100% 65% / 0.18)',
      '--shadow-2xl': '0 0px 40px -10px hsl(0 100% 65% / 0.25)',
    },
    light: {
      '--background': 'oklch(1.0000 0 0)', '--foreground': 'oklch(0.1452 0.0021 286.1313)',
      '--card': 'oklch(0.9842 0.0034 247.8575)', '--card-foreground': 'oklch(0.1452 0.0021 286.1313)',
      '--popover': 'oklch(0.9842 0.0034 247.8575)', '--popover-foreground': 'oklch(0.1452 0.0021 286.1313)',
      '--primary': 'oklch(0.6730 0.2146 25.0397)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.7845 0.1325 181.9120)', '--secondary-foreground': 'oklch(0.2077 0.0398 265.7549)',
      '--muted': 'oklch(0.9702 0 0)', '--muted-foreground': 'oklch(0.5555 0 0)',
      '--accent': 'oklch(0.9288 0.0126 255.5078)', '--accent-foreground': 'oklch(0.1452 0.0021 286.1313)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.9288 0.0126 255.5078)', '--input': 'oklch(0.9288 0.0126 255.5078)',
      '--ring': 'oklch(0.6730 0.2146 25.0397)',
      '--chart-1': 'oklch(0.6730 0.2146 25.0397)', '--chart-2': 'oklch(0.7845 0.1325 181.9120)',
      '--chart-3': 'oklch(0.5500 0.1800 25.0000)', '--chart-4': 'oklch(0.6500 0.1100 181.0000)',
      '--chart-5': 'oklch(0.8000 0.1500 60.0000)',
      '--sidebar': 'oklch(0.9842 0.0034 247.8575)', '--sidebar-foreground': 'oklch(0.1452 0.0021 286.1313)',
      '--sidebar-primary': 'oklch(0.6730 0.2146 25.0397)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.9288 0.0126 255.5078)', '--sidebar-accent-foreground': 'oklch(0.1452 0.0021 286.1313)',
      '--sidebar-border': 'oklch(0.9288 0.0126 255.5078)', '--sidebar-ring': 'oklch(0.6730 0.2146 25.0397)',
    },
    dark: {
      '--background': 'oklch(0.0969 0 0)', '--foreground': 'oklch(0.9842 0.0034 247.8575)',
      '--card': 'oklch(0.1408 0.0044 285.8229)', '--card-foreground': 'oklch(0.9842 0.0034 247.8575)',
      '--popover': 'oklch(0.1408 0.0044 285.8229)', '--popover-foreground': 'oklch(0.9842 0.0034 247.8575)',
      '--primary': 'oklch(0.6730 0.2146 25.0397)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.7845 0.1325 181.9120)', '--secondary-foreground': 'oklch(0.0969 0 0)',
      '--muted': 'oklch(0.2046 0 0)', '--muted-foreground': 'oklch(0.7155 0 0)',
      '--accent': 'oklch(0.2739 0.0055 286.0326)', '--accent-foreground': 'oklch(0.9842 0.0034 247.8575)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.2739 0.0055 286.0326)', '--input': 'oklch(0.2739 0.0055 286.0326)',
      '--ring': 'oklch(0.6730 0.2146 25.0397)',
      '--chart-1': 'oklch(0.6730 0.2146 25.0397)', '--chart-2': 'oklch(0.7845 0.1325 181.9120)',
      '--chart-3': 'oklch(0.5500 0.1800 25.0000)', '--chart-4': 'oklch(0.6500 0.1100 181.0000)',
      '--chart-5': 'oklch(0.8000 0.1500 60.0000)',
      '--sidebar': 'oklch(0.0969 0 0)', '--sidebar-foreground': 'oklch(0.9842 0.0034 247.8575)',
      '--sidebar-primary': 'oklch(0.6730 0.2146 25.0397)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.2739 0.0055 286.0326)', '--sidebar-accent-foreground': 'oklch(0.9842 0.0034 247.8575)',
      '--sidebar-border': 'oklch(0.2739 0.0055 286.0326)', '--sidebar-ring': 'oklch(0.6730 0.2146 25.0397)',
    },
  },

  // ═══ Pastel ═══
  {
    id: 'pastel',
    name: 'Pastel',
    preview: [
      'oklch(0.8027 0.1355 349.2347)',
      'oklch(0.3210 0.0078 223.6661)',
      'oklch(0.8148 0.0819 225.7537)',
      'oklch(0.3867 0 0)',
    ],
    shared: {
      '--font-sans': 'Poppins, sans-serif',
      '--font-serif': 'Lora, serif',
      '--font-mono': 'Roboto Mono, monospace',
      '--radius': '0.5rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '0em',
      '--shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-xs':  '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-sm':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow':     '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-md':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-lg':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-xl':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
    },
    light: {
      '--background': 'oklch(0.9809 0.0025 228.7836)', '--foreground': 'oklch(0.3211 0 0)',
      '--card': 'oklch(1.0000 0 0)', '--card-foreground': 'oklch(0.3211 0 0)',
      '--popover': 'oklch(1.0000 0 0)', '--popover-foreground': 'oklch(0.3211 0 0)',
      '--primary': 'oklch(0.8677 0.0735 7.0855)', '--primary-foreground': 'oklch(0 0 0)',
      '--secondary': 'oklch(0.8148 0.0819 225.7537)', '--secondary-foreground': 'oklch(0 0 0)',
      '--muted': 'oklch(0.8828 0.0285 98.1033)', '--muted-foreground': 'oklch(0.5382 0 0)',
      '--accent': 'oklch(0.9500 0.0100 228)', '--accent-foreground': 'oklch(0.3211 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.9219 0 0)', '--input': 'oklch(0.9219 0 0)',
      '--ring': 'oklch(0.8677 0.0735 7.0855)',
      '--chart-1': 'oklch(0.8677 0.0735 7.0855)', '--chart-2': 'oklch(0.8148 0.0819 225.7537)',
      '--chart-3': 'oklch(0.9680 0.2110 109.7692)', '--chart-4': 'oklch(0.8828 0.0285 98.1033)',
      '--chart-5': 'oklch(0.7500 0.1000 350.0000)',
      '--sidebar': 'oklch(0.9809 0.0025 228.7836)', '--sidebar-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-primary': 'oklch(0.8677 0.0735 7.0855)', '--sidebar-primary-foreground': 'oklch(0 0 0)',
      '--sidebar-accent': 'oklch(0.9500 0.0100 228)', '--sidebar-accent-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-border': 'oklch(0.9219 0 0)', '--sidebar-ring': 'oklch(0.8677 0.0735 7.0855)',
    },
    dark: {
      '--background': 'oklch(0.2303 0.0125 264.2926)', '--foreground': 'oklch(0.9219 0 0)',
      '--card': 'oklch(0.3210 0.0078 223.6661)', '--card-foreground': 'oklch(0.9219 0 0)',
      '--popover': 'oklch(0.3210 0.0078 223.6661)', '--popover-foreground': 'oklch(0.9219 0 0)',
      '--primary': 'oklch(0.8027 0.1355 349.2347)', '--primary-foreground': 'oklch(0 0 0)',
      '--secondary': 'oklch(0.7395 0.2268 142.8504)', '--secondary-foreground': 'oklch(0 0 0)',
      '--muted': 'oklch(0.3867 0 0)', '--muted-foreground': 'oklch(0.7155 0 0)',
      '--accent': 'oklch(0.3200 0.0100 225)', '--accent-foreground': 'oklch(0.9219 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3867 0 0)', '--input': 'oklch(0.3867 0 0)',
      '--ring': 'oklch(0.8027 0.1355 349.2347)',
      '--chart-1': 'oklch(0.8027 0.1355 349.2347)', '--chart-2': 'oklch(0.7395 0.2268 142.8504)',
      '--chart-3': 'oklch(0.8148 0.0819 225.7537)', '--chart-4': 'oklch(0.9680 0.2110 109.7692)',
      '--chart-5': 'oklch(0.7155 0 0)',
      '--sidebar': 'oklch(0.2303 0.0125 264.2926)', '--sidebar-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-primary': 'oklch(0.8027 0.1355 349.2347)', '--sidebar-primary-foreground': 'oklch(0 0 0)',
      '--sidebar-accent': 'oklch(0.3200 0.0100 225)', '--sidebar-accent-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-border': 'oklch(0.3867 0 0)', '--sidebar-ring': 'oklch(0.8027 0.1355 349.2347)',
    },
  },

  // ═══ Aqua ═══
  {
    id: 'aqua',
    name: 'Aqua',
    preview: [
      'oklch(0.6509 0.1283 170.4258)',
      'oklch(0.2848 0.0230 235.6578)',
      'oklch(0.7610 0.2015 149.7403)',
      'oklch(0.3351 0.0253 234.8586)',
    ],
    shared: {
      '--font-sans': "Segoe UI, Helvetica Neue, Helvetica, Arial, sans-serif",
      '--font-serif': "Georgia, Cambria, 'Times New Roman', Times, serif",
      '--font-mono': "Consolas, 'Courier New', monospace",
      '--radius': '1rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '0em',
      '--shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-xs':  '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
      '--shadow-sm':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow':     '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-md':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-lg':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-xl':  '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
      '--shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
    },
    light: {
      '--background': 'oklch(0.9605 0.0046 258.3248)', '--foreground': 'oklch(0.3211 0 0)',
      '--card': 'oklch(1.0000 0 0)', '--card-foreground': 'oklch(0.3211 0 0)',
      '--popover': 'oklch(1.0000 0 0)', '--popover-foreground': 'oklch(0.3211 0 0)',
      '--primary': 'oklch(0.4335 0.0754 182.2315)', '--primary-foreground': 'oklch(1.0000 0 0)',
      '--secondary': 'oklch(0.9644 0.0208 166.1014)', '--secondary-foreground': 'oklch(0.3211 0 0)',
      '--muted': 'oklch(0.9219 0 0)', '--muted-foreground': 'oklch(0.5555 0 0)',
      '--accent': 'oklch(0.9400 0.0100 258)', '--accent-foreground': 'oklch(0.3211 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.8699 0 0)', '--input': 'oklch(0.8699 0 0)',
      '--ring': 'oklch(0.4335 0.0754 182.2315)',
      '--chart-1': 'oklch(0.4335 0.0754 182.2315)', '--chart-2': 'oklch(0.7610 0.2015 149.7403)',
      '--chart-3': 'oklch(0.5500 0.0900 182.0000)', '--chart-4': 'oklch(0.6500 0.1500 149.0000)',
      '--chart-5': 'oklch(0.3500 0.0600 182.0000)',
      '--sidebar': 'oklch(0.9605 0.0046 258.3248)', '--sidebar-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-primary': 'oklch(0.4335 0.0754 182.2315)', '--sidebar-primary-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-accent': 'oklch(0.9400 0.0100 258)', '--sidebar-accent-foreground': 'oklch(0.3211 0 0)',
      '--sidebar-border': 'oklch(0.8699 0 0)', '--sidebar-ring': 'oklch(0.4335 0.0754 182.2315)',
    },
    dark: {
      '--background': 'oklch(0.1854 0.0182 238.2143)', '--foreground': 'oklch(0.9219 0 0)',
      '--card': 'oklch(0.2848 0.0230 235.6578)', '--card-foreground': 'oklch(0.9219 0 0)',
      '--popover': 'oklch(0.2848 0.0230 235.6578)', '--popover-foreground': 'oklch(0.9219 0 0)',
      '--primary': 'oklch(0.6509 0.1283 170.4258)', '--primary-foreground': 'oklch(0.1854 0.0182 238.2143)',
      '--secondary': 'oklch(0.3351 0.0253 234.8586)', '--secondary-foreground': 'oklch(0.9219 0 0)',
      '--muted': 'oklch(0.3351 0.0253 234.8586)', '--muted-foreground': 'oklch(0.7155 0 0)',
      '--accent': 'oklch(0.3200 0.0150 235)', '--accent-foreground': 'oklch(0.9219 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3351 0.0253 234.8586)', '--input': 'oklch(0.3351 0.0253 234.8586)',
      '--ring': 'oklch(0.6509 0.1283 170.4258)',
      '--chart-1': 'oklch(0.6509 0.1283 170.4258)', '--chart-2': 'oklch(0.7610 0.2015 149.7403)',
      '--chart-3': 'oklch(0.5500 0.1000 170.0000)', '--chart-4': 'oklch(0.6000 0.1500 149.0000)',
      '--chart-5': 'oklch(0.4335 0.0754 182.2315)',
      '--sidebar': 'oklch(0.1854 0.0182 238.2143)', '--sidebar-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-primary': 'oklch(0.6509 0.1283 170.4258)', '--sidebar-primary-foreground': 'oklch(0.1854 0.0182 238.2143)',
      '--sidebar-accent': 'oklch(0.3200 0.0150 235)', '--sidebar-accent-foreground': 'oklch(0.9219 0 0)',
      '--sidebar-border': 'oklch(0.3351 0.0253 234.8586)', '--sidebar-ring': 'oklch(0.6509 0.1283 170.4258)',
    },
  },

  // ═══ Neon ═══
  {
    id: 'neon',
    name: 'Neon',
    preview: [
      'oklch(0.6726 0.2904 341.4084)',
      'oklch(0 0 0)',
      'oklch(0.2520 0 0)',
      'oklch(0.3211 0 0)',
    ],
    shared: {
      '--font-sans': 'Outfit, sans-serif',
      '--font-serif': 'serif',
      '--font-mono': 'Fira Code, monospace',
      '--radius': '0.5rem',
      '--spacing': '0.25rem',
      '--tracking-normal': '0em',
      '--shadow-2xs': '0 0 5px hsl(330 100% 60% / 0.10)',
      '--shadow-xs':  '0 0 5px hsl(330 100% 60% / 0.15)',
      '--shadow-sm':  '0 0 10px hsl(330 100% 60% / 0.15)',
      '--shadow':     '0 0 15px hsl(330 100% 60% / 0.20)',
      '--shadow-md':  '0 0 20px hsl(330 100% 60% / 0.25)',
      '--shadow-lg':  '0 0 30px hsl(330 100% 60% / 0.25)',
      '--shadow-xl':  '0 0 40px hsl(330 100% 60% / 0.30)',
      '--shadow-2xl': '0 0 50px hsl(330 100% 60% / 0.40)',
    },
    light: {
      '--background': 'oklch(0 0 0)', '--foreground': 'oklch(1.0000 0 0)',
      '--card': 'oklch(0 0 0)', '--card-foreground': 'oklch(1.0000 0 0)',
      '--popover': 'oklch(0 0 0)', '--popover-foreground': 'oklch(1.0000 0 0)',
      '--primary': 'oklch(0.6726 0.2904 341.4084)', '--primary-foreground': 'oklch(0 0 0)',
      '--secondary': 'oklch(0.2520 0 0)', '--secondary-foreground': 'oklch(1.0000 0 0)',
      '--muted': 'oklch(0.1776 0 0)', '--muted-foreground': 'oklch(0.7380 0 0)',
      '--accent': 'oklch(0.2200 0 0)', '--accent-foreground': 'oklch(1.0000 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3211 0 0)', '--input': 'oklch(0.2178 0 0)',
      '--ring': 'oklch(0.6726 0.2904 341.4084)',
      '--chart-1': 'oklch(0.6726 0.2904 341.4084)', '--chart-2': 'oklch(0.7000 0.2000 300.0000)',
      '--chart-3': 'oklch(0.7500 0.1500 200.0000)', '--chart-4': 'oklch(0.8000 0.2000 130.0000)',
      '--chart-5': 'oklch(0.7380 0 0)',
      '--sidebar': 'oklch(0 0 0)', '--sidebar-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-primary': 'oklch(0.6726 0.2904 341.4084)', '--sidebar-primary-foreground': 'oklch(0 0 0)',
      '--sidebar-accent': 'oklch(0.2200 0 0)', '--sidebar-accent-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-border': 'oklch(0.3211 0 0)', '--sidebar-ring': 'oklch(0.6726 0.2904 341.4084)',
    },
    dark: {
      '--background': 'oklch(0 0 0)', '--foreground': 'oklch(1.0000 0 0)',
      '--card': 'oklch(0 0 0)', '--card-foreground': 'oklch(1.0000 0 0)',
      '--popover': 'oklch(0 0 0)', '--popover-foreground': 'oklch(1.0000 0 0)',
      '--primary': 'oklch(0.6726 0.2904 341.4084)', '--primary-foreground': 'oklch(0 0 0)',
      '--secondary': 'oklch(0.2520 0 0)', '--secondary-foreground': 'oklch(1.0000 0 0)',
      '--muted': 'oklch(0.1776 0 0)', '--muted-foreground': 'oklch(0.7380 0 0)',
      '--accent': 'oklch(0.2200 0 0)', '--accent-foreground': 'oklch(1.0000 0 0)',
      '--destructive': 'oklch(0.6368 0.2078 25.3313)', '--destructive-foreground': 'oklch(1.0000 0 0)',
      '--border': 'oklch(0.3211 0 0)', '--input': 'oklch(0.2178 0 0)',
      '--ring': 'oklch(0.6726 0.2904 341.4084)',
      '--chart-1': 'oklch(0.6726 0.2904 341.4084)', '--chart-2': 'oklch(0.7000 0.2000 300.0000)',
      '--chart-3': 'oklch(0.7500 0.1500 200.0000)', '--chart-4': 'oklch(0.8000 0.2000 130.0000)',
      '--chart-5': 'oklch(0.7380 0 0)',
      '--sidebar': 'oklch(0 0 0)', '--sidebar-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-primary': 'oklch(0.6726 0.2904 341.4084)', '--sidebar-primary-foreground': 'oklch(0 0 0)',
      '--sidebar-accent': 'oklch(0.2200 0 0)', '--sidebar-accent-foreground': 'oklch(1.0000 0 0)',
      '--sidebar-border': 'oklch(0.3211 0 0)', '--sidebar-ring': 'oklch(0.6726 0.2904 341.4084)',
    },
  },
]

export function applyTheme(theme: ThemeDef, mode: 'light' | 'dark') {
  const root = document.documentElement
  const colors = mode === 'dark' ? theme.dark : theme.light
  for (const [key, value] of Object.entries(theme.shared)) {
    root.style.setProperty(key, value)
  }
  for (const [key, value] of Object.entries(colors)) {
    root.style.setProperty(key, value)
  }
}

export function getThemeById(id: string): ThemeDef | undefined {
  return themes.find(t => t.id === id)
}
